import Vue from 'vue'
import VueRouter from 'vue-router'

import {Parameter} from '@/router/Parameter/Parameter';

import HomePage from "@/views/HomePage.vue";
import {Physician} from "@/router/Physician";
import {Pharmacy} from "@/router/Pharmacy";
import {Wholesaler} from "@/router/Wholesaler";
import {VisitPhysician} from "@/router/VisitPhysician";
import {VisitPharmacy} from "@/router/VisitPharmacy";
import {VisitWholesaler} from "@/router/VisitWholesaler";
import {ActivityReport} from "@/router/ActivityReport";
import {Expense} from "@/router/Expense";
import {DeduplicationPhysician} from "@/router/DeduplicationPhysician";
import {DeduplicationPharmacy} from "@/router/DeduplicationPharmacy";
import {DeduplicationWholesaler} from "@/router/DeduplicationWholesaler";

import {AnalysisPhysician} from "@/router/Analysis/AnalysisPhysician";
import {AnalysisPharmacy} from "@/router/Analysis/AnalysisPharmacy";
import {AnalysisWholesaler} from "@/router/Analysis/AnalysisWholesaler";

import {PromotionCampaign} from "@/router/PromotionCampaign";
import {Product} from "@/router/Product";
import {Delegate} from "@/router/Delegate";
import {Role} from "@/router/Role";

import {AnalysisCustomerDetail} from "@/router/Analysis/AnalysisCustomerDetail";
import {AnalysisVisitDetail} from "@/router/Analysis/AnalysisVisitDetail";

Vue.use(VueRouter);


const routes = [
    {
        path: '/',
        name: 'home',
        component: HomePage,
        children: [
            Parameter,

            Physician,
            Pharmacy,
            Wholesaler,

            VisitPhysician,
            VisitPharmacy,
            VisitWholesaler,

            ActivityReport,

            Expense,

            DeduplicationPhysician,
            DeduplicationPharmacy,
            DeduplicationWholesaler,

            AnalysisPhysician,
            AnalysisPharmacy,
            AnalysisWholesaler,

            PromotionCampaign,
            Product,
            Delegate,
            Role,
        ],
    },
    AnalysisCustomerDetail,
    AnalysisVisitDetail,
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Setting/Login/LoginView.vue'),
    },
    {
        path: '/reset_password',
        name: 'reset_password',
        component: () => import('@/views/Setting/ResetPassword/ResetPassword.vue'),
    },
    {
        path: '*',
        name: 'not_found',
        component: () => import('@/views/PageNotFound.vue')
    },
]

const router = new VueRouter({
    routes
})

export default router
